import { Printer } from '@/features/print/types'
import { FormKeys } from '@/features/settings/components/PrinterConfiguration/form/constants'
import { Form } from '@/features/settings/components/PrinterConfiguration/form/types'

export const mapFormValuesToPrinter = (form: Form, printer: Printer): Printer => {
    return {
        ...printer,
        name: form[FormKeys.Name] === '' ? null : form[FormKeys.Name],
        printTypes: form[FormKeys.PrintTypes],
        charsPerLine: parseInt(form[FormKeys.CharsPerLine]),
        paperWidth: parseInt(form[FormKeys.PaperWidth]),
    }
}

export const mapPrinterToFormValues = (printer: Printer): Form => {
    return {
        name: printer.name || '',
        printTypes: printer.printTypes,
        charsPerLine: printer.charsPerLine.toString(),
        paperWidth: printer.paperWidth.toString(),
    }
}
